import {useContext, useEffect} from 'react'
import styles from "../../css/toast.module.css"
import ToastContext from "../../config/context/toastContext";

//status: success/error/warning
function Toast({text, status, index, removeToastFromList, executable, executableFunction  }) {
    const { toastList, setToastList } = useContext(ToastContext);

    useEffect(() => {
        if (toastList.length === 0) return;
        //toast se sam brise nakon 5s
        setTimeout(() => {
            //ako nije selfDestructible prekida se uklanjanje dokle god se ne ide na klik
          if (toastList[toastList.length - 1].selfDestructible === false) return;
          let tempList = [...toastList].slice(1);
          setToastList(tempList);
        }, 5000);
      }, [toastList]);

   const executeOnClick=()=>{
    if(executable){
        executableFunction();
    }
    removeToastFromList(index)
   }

    return (
        <div onClick={executeOnClick} className={` ${styles.toast} ${styles[status]} `}>
            <p> {text} </p>
        </div>
    )
}

export default Toast